module.exports = "pegasus/assets/theme5/google-icon-1.png";